import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from '~shared/not-found/not-found.component';
import { LoginComponent } from '~shared/login/login.component';
import { SsoComponent } from '~shared/sso/sso.component';

import { AuthGuardService } from '../app/common/service/auth/auth-guard.service';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'authentication',
  //   pathMatch: 'full'
  // },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'failed',
    component: NotFoundComponent
  },
  {
    path: '',
    loadChildren: () => import('./module/student/student.module').then(m => m.StudentModule),
    canActivateChild: [AuthGuardService],
  },
  {
    path: 'admin',
    loadChildren: () => import('./module/admin/admin.module').then(m => m.AdminModule),
    canActivateChild: [AuthGuardService],
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sso',
    component: SsoComponent
  },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
